import { Button, Dialog, Input } from '@zyxantech/tux'
import { useState } from 'react'

interface NewCustomerDialogProps {
  isLoading: boolean
  onCreate: (tenantName: string, tenantSlug: string) => Promise<void>
  onClose: () => void
}

function toSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function NewCustomerDialog({ isLoading, onCreate, onClose }: NewCustomerDialogProps) {
  const [name, setName] = useState('')
  const [slug, setSlug] = useState('')
  const [slugTouched, setSlugTouched] = useState(false)

  const handleNameChange = (value: string) => {
    setName(value)
    if (!slugTouched) setSlug(toSlug(value))
  }

  const handleSlugChange = (value: string) => {
    setSlug(value)
    setSlugTouched(true)
  }

  const canSubmit = name.trim().length > 0 && slug.trim().length > 0

  return (
    <Dialog
      title="New customer"
      open
      onClose={onClose}
      width={480}
      footer={
        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={!canSubmit || isLoading}
            loading={isLoading}
            onClick={() => void onCreate(name.trim(), slug.trim())}
          >
            Provision
          </Button>
        </div>
      }
    >
      <div className="space-y-4">
        <div>
          <label className="mb-1.5 block text-sm font-medium text-text-primary">
            Tenant name <span className="text-danger">*</span>
          </label>
          <Input
            value={name}
            onChange={(e) => handleNameChange(e.target.value)}
            placeholder="Acme Corp"
            autoFocus
          />
        </div>
        <div>
          <label className="mb-1.5 block text-sm font-medium text-text-primary">
            Slug <span className="text-danger">*</span>
          </label>
          <Input
            value={slug}
            onChange={(e) => handleSlugChange(e.target.value)}
            placeholder="acme-corp"
            className="font-mono"
          />
          <p className="mt-1 text-xs text-text-muted">
            URL-safe identifier — auto-generated from name. Must be unique.
          </p>
        </div>
      </div>
    </Dialog>
  )
}
